import React from 'react'
import { makeStyles } from '@material-ui/styles'
import BaseCopilotInsightCard from './BaseCopilotInsightWidget'
import IconAndText from 'components/common/IconAndText'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { Grid } from '@material-ui/core'
import Tooltip from 'components/common/Tooltip'
import InfoTooltip from '../../CopilotSettings/icons/Insights/InfoTooltip'
import { useTranslation } from 'react-i18next'
import { Skeleton } from '@material-ui/lab'

const useStyles = makeStyles(theme => ({
  copilotMetric: {
    width: '180px',
    height: '95px'
  }
}))

const PatientCopilotMetricWidget = ({
  titleIcon,
  title,
  metricIcon,
  metricLabel,
  labelColor,
  tooltip,
  noData = false,
  isLoading = false
}) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return isLoading ? (
    <Skeleton variant="rect" className={classes.copilotMetric} style={{ borderRadius: 16 }} />
  ) : (
    <BaseCopilotInsightCard className={classes.copilotMetric}>
      <Grid container direction="column" style={{ height: '100%' }} justifyContent="space-between">
        <Grid item>
          <IconAndText icon={titleIcon} text={<DazzedParagraph14>{title}</DazzedParagraph14>} />
        </Grid>
        {noData ? (
          <Grid item>
            <DazzedParagraph14 strong textAlign="center" color="var(--text-color-18)">
              {t('pages.patients.patientSidebar.items.copilot.copilotInsights.noDataAvailable')}
            </DazzedParagraph14>
          </Grid>
        ) : (
          <Grid item>
            <Grid container alignItems="center" justifyContent="center">
              <Grid item>
                <IconAndText
                  margin="8px"
                  icon={metricIcon}
                  text={
                    <DazzedParagraph14 color={labelColor} strong>
                      {metricLabel}
                    </DazzedParagraph14>
                  }
                />
              </Grid>
              {tooltip && (
                <Grid item style={{ lineHeight: 0.8, marginLeft: '5px' }}>
                  <Tooltip value={tooltip} placement="top" arrow>
                    <InfoTooltip />
                  </Tooltip>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
      </Grid>
    </BaseCopilotInsightCard>
  )
}

export default PatientCopilotMetricWidget
